<template>
    <AuthForm 
        auth-type="signup" 
        :loading="loading" 
        :error="error"
        @form-submit="handleSignup"
    />
</template>

<script>
import AuthForm from "@/components/auth/AuthForm.vue";

export default {
    name: "SignupPage",

    components: {
        AuthForm,
    },

    data() {
        return {
            error: {
                show: false,
                value: "",
            },
            loading: false,
        };
    },

    computed: {
        isNewUser() {
            return this.$store.getters["app/isNewUser"];
        },

        selectedPlan() {
            return this.$store.getters["app/selectedPlan"];
        },
    },

    methods: {
        async handleSignup(payload) {
            try {
                this.error.show = false;
                this.error.value = "";
                this.loading = true;

                const res = await this.$store.dispatch("auth/signup", payload);
                this.loading = false;

                // handle token failure
                const ongoingSession = res?.redirect && res.redirect_type === "token_valid";
                const redirectPath = this.$route.query.redirect;

                if (ongoingSession) {
                    if (redirectPath) {
                        return this.$router.push(`${redirectPath}`);
                    } else {
                        return this.$router.push("/dashboard/getting-started");
                    }
                }
  
                this.$toast.success("Signup successful");

                if (this.selectedPlan === "free") {
                    this.$store.dispatch("app/toggleNewUser", true);                    
                    this.$router.push({ name: "reports", query: { type: "clients", range: "1_year" } });
                    return;
                }

                this.$store.dispatch("app/setInitiatePaidPlan", true);
                this.$router.push("/initiate-plan");  
                return;            
            } catch (error) {
                const errMsg = error?.response?.data?.message || error?.message;
                this.error.value = errMsg;
                this.error.show = true;
                this.$toast.error(errMsg);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>